<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import Work Orders to Undo Completion"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Undo completion on work orders."
      @on-submit="createUndoWorkOrdersCompletionImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Work Orders to Undo Completion Template.xlsx"
              :file-provider="$importsAPI.getUndoWorkOrdersCompletionTemplate"
            />
          </b-col>
        </b-row>
      </template>
      >
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'UndoWorkOrdersCompletionImportNewModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'undo-work-orders-completion-imports-add-modal',
    };
  },
  methods: {
    createUndoWorkOrdersCompletionImport(data, handleCreate) {
      handleCreate(this.$importsAPI.undoWorkOrdersCompletionCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
